import React, { PureComponent } from "react";
import PageLink from "../../../components/Page/PageLink";
import Footer from "../../../components/Footer/Footer";
import InterfaceProperties from "../../../components/Interface/InterfaceProperties";
import InterfaceCompatibility from "../../../components/Interface/InterfaceCompatibility";

class Component_record_timestamp extends PureComponent {
  render() {
    return (
      <div className="row" id="component_record_timestamp">
        <div className="col-md-6">
          <div className="contentLight">
            <section>
              <h2>Record Timestamp</h2>
              <p>
                TimeStamp is a label component that displays a DateTime time
                stamp in a record. The TimeStamp is read-only; however, it does
                allow users to interact with it, changing the DateTime format.
              </p>

              <InterfaceCompatibility
                dashboard={false}
                record={true}
                report={false}
                search={false}
              />
              <InterfaceProperties
                type={"record_timestamp"}
                name={"timestamp "}
                dataNameDefault={
                  '"date_my_field" or "object_my_obj.date_my_field"'
                }
                padding={true}
                hide={true}
                order={true}
                button={false}
                tabIndex={true}
                readOnly={false}
                displayName={true}
                onChangeEval={true}
              />
              <Footer
                section={this.props.section}
                article={this.props.article}
                routeParams={this.props.routeParams}
              />
            </section>
          </div>
        </div>
        <div className="col-md-6 darkCol">
          <div className="contentDark">
            <section>
              <h2>Record Timestamp Example</h2>
            </section>
            <section>
              <h3>Example 1: Simple Timestamp</h3>
              <div className="darkCode">
                <div>&#123;</div>
                <strong>
                  <div className="i1">
                    <span className="jsonG">"type"</span>:{" "}
                    <span className="jsonY">"record_timestamp"</span>,
                  </div>
                </strong>
                <div className="i1">
                  <span className="jsonG">"data_name"</span>:{" "}
                  <span className="jsonY">"date_my_field"</span>,
                </div>
                <div className="i1">
                  <span className="jsonG">"display_name"</span>:{" "}
                  <span className="jsonY">"My Field"</span>
                </div>
                <div>&#125;</div>
              </div>
            </section>
            <section>
              <h3>Example 2: Record Created Timestamp</h3>
              <div className="darkCode">
                <div>&#123;</div>
                <strong>
                  <div className="i1">
                    <span className="jsonG">"type"</span>:{" "}
                    <span className="jsonY">"record_timestamp"</span>,
                  </div>
                </strong>
                <div className="i1">
                  <span className="jsonG">"data_name"</span>:{" "}
                  <span className="jsonY">
                    "object_created_by.date_created"
                  </span>
                  ,
                </div>
                <div className="i1">
                  <span className="jsonG">"display_name"</span>:{" "}
                  <span className="jsonY">"Record Created On"</span>
                </div>
                <div>&#125;</div>
              </div>
            </section>
          </div>
        </div>
      </div>
    );
  }
}

export default Component_record_timestamp;



// WEBPACK FOOTER //
// ./src/components/knowlege/interface/Component_record_timestamp.js